module.exports = __webpack_public_path__ + "img/prata.c364b1c9.png";